import { render, staticRenderFns } from "./DrawerApp.vue?vue&type=template&id=64745a41&scoped=true"
import script from "./DrawerApp.vue?vue&type=script&lang=js"
export * from "./DrawerApp.vue?vue&type=script&lang=js"
import style0 from "./DrawerApp.vue?vue&type=style&index=0&id=64745a41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64745a41",
  null
  
)

export default component.exports